export const cmToInch = 0.393700787;
export const QRSizeInCm = 8;
